var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialSymbolsEditRoundedBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.225 6.62734L11.0375 3.47734L12.0875 2.42734C12.375 2.13984 12.7283 1.99609 13.1473 1.99609C13.5658 1.99609 13.9188 2.13984 14.2063 2.42734L15.2563 3.47734C15.5438 3.76484 15.6938 4.11184 15.7063 4.51834C15.7188 4.92434 15.5813 5.27109 15.2938 5.55859L14.225 6.62734ZM2.75 15.6836C2.5375 15.6836 2.3595 15.6116 2.216 15.4676C2.072 15.3241 2 15.1461 2 14.9336V12.8148C2 12.7148 2.01875 12.6181 2.05625 12.5246C2.09375 12.4306 2.15 12.3461 2.225 12.2711L9.95 4.54609L13.1375 7.73359L5.4125 15.4586C5.3375 15.5336 5.25325 15.5898 5.15975 15.6273C5.06575 15.6648 4.96875 15.6836 4.86875 15.6836H2.75Z",
    fill: "#009BD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsEditRoundedBlue);
export default __webpack_public_path__ + "static/media/material-symbols_edit-rounded_blue.48fec26d6f8097714ff18886a781f9c0.svg";
export { ForwardRef as ReactComponent };